export default __webpack_public_path__ + "static/media/dash-logo.790b2350.svg";